export default [{
  path: '/transfer',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/transfer.vue'], resolve),
  name: 'transfer',
  title: '调拨管理',
  meta: {
    title: '调拨管理'
  }
}, {
  path: '/damaged',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/damaged.vue'], resolve),
  name: 'damaged',
  title: '出库管理',
  meta: {
    title: '出库管理'
  }
}, {
  path: '/addTransfer',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/addTransfer.vue'], resolve),
  name: 'addTransfer',
  title: '新增调拨',
  meta: {
    title: '新增调拨'
  }
}, {
  path: '/addDamaged',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/addDamaged.vue'], resolve),
  name: 'addDamaged',
  title: '新增出库',
  meta: {
    title: '新增出库'
  }
}, {
  path: '/checkOrder',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/checkOrder.vue'], resolve),
  name: 'checkOrder',
  title: '收银台',
  meta: {
    title: '收银台'
  }
}, {
  path: '/supplier',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/supplier.vue'], resolve),
  name: 'supplier',
  title: '供应商',
  meta: {
    title: '供应商'
  }
}, {
  path: '/saleSite',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/saleSite.vue'], resolve),
  name: 'saleSite',
  title: '销售点位',
  meta: {
    title: '销售点位'
  }
}, {
  path: '/siteGoodsManage',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/siteGoodsManage.vue'], resolve),
  name: 'siteGoodsManage',
  title: '点位售品管理',
  meta: {
    title: '点位售品管理'
  }
}, {
  path: '/goodsClass',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/goodsClass.vue'], resolve),
  name: 'goodsClass',
  title: '商品分类',
  meta: {
    title: '商品分类'
  }
}, {
  path: '/warehousing',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/warehousing.vue'], resolve),
  name: 'warehousing',
  title: '库存盘点表',
  meta: {
    title: '库存盘点表'
  }
}, {
  path: '/goodsSaleManage',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/goodsManage.vue'], resolve),
  name: 'goodsSaleManage',
  title: '商品信息',
  meta: {
    title: '商品信息'
  }
}, {
  path: '/purchase',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/purchase.vue'], resolve),
  name: 'purchase',
  title: '入库管理',
  meta: {
    title: '入库管理'
  }
}, {
  path: '/addPurchase',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/addPurchase.vue'], resolve),
  name: 'addPurchase',
  title: '新增入库',
  meta: {
    title: '新增入库'
  }
}, {
  path: '/checkStock',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/checkStock.vue'], resolve),
  name: 'checkStock',
  title: '盘库管理',
  meta: {
    title: '盘库管理'
  }
}, {
  path: '/editStock',
  component: resolve =>
    require(['../pages/saleSystem/goodsSore/editStock.vue'], resolve),
  name: 'editStock',
  title: '录入盘库',
  meta: {
    title: '录入盘库'
  }
}, {
  path: '/productPriceMember',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/productPriceMember.vue'], resolve),
  name: 'productPriceMember',
  title: '会员折扣',
  meta: {
    title: '会员折扣'
  }
}, {
  path: '/saleOrderList',
  component: resolve =>
    require(['../pages/saleSystem/orderManage/saleOrderList.vue'], resolve),
  name: 'saleOrderList',
  title: '销售订单',
  meta: {
    title: '销售订单'
  }
},
  {
    path: '/setSaleSite',
    component: resolve =>
      require(['../pages/saleSystem/orderManage/setSaleSite.vue'], resolve),
    name: 'setSaleSite',
    title: '营业点分配',
    meta: {
      title: '营业点分配'
    }
  }

]
